// admin后端api地址

let baseUrl = ""

let system_url= "/admin";
// shopping 后端api地址
let appli_url= '/shopping';
//socketshopping地址
let socket_url= 'ws://127.0.0.1:5090/web';
//workbench地址
let workbench_url= '/workbench';
// security地址
let security_url= '/security'; 
// app-manager地址
let manager_url= '/app-manager';
// rbac地址
let rbac_url= '/rbac';
// resource地址
let resource_url= '/rbac';
// message地址
let message_url= '/message';
let task_url= '/task';
let file_url= '';

// 官网api地址
let official_url = "/zr-websiteback-api"
// 官网地址
let official_web_url = "/?topage="
// 官网图片地址
let official_web_img_url = ""

export {
    baseUrl,
    official_url,
    official_web_url,
    official_web_img_url,
    system_url,
    socket_url,
    appli_url,
    workbench_url,
    security_url,
    manager_url,
    rbac_url,
    resource_url,
    message_url,
    file_url,
    task_url
}



// WEBPACK FOOTER //
// ./src/api/baseUrl.js